import React from 'react'
import config from '../../config'

const MenuConfig = [
  [
    [
      config.routes.home,
      'Home',
      'l'
    ],
    [
      config.routes.about,
      'About us',
      'l'
    ],
    [
      config.routes.howitworks,
      'How it works',
      's'
    ],
    [
      config.links.contact,
      'Contact us',
      's'
    ],
    [
      config.routes.legal,
      'Legal disclaimer',
      's'
    ],
  ],
  [
    [
      config.routes.clean,
      'Search funds',
      'l',
      'search'
    ],
    [
      config.routes.companies,
      'Prison industrial complex companies',
      'l'
    ],

    // [
    //   config.routes.indexfunds,
    //   'Index funds',
    //   's'
    // ],
    // [
    //   config.routes.targetdate,
    //   'Target date funds',
    //   's'
    // ],
    // [
    //   config.routes.families,
    //   'Fund managers',
    //   'l'
    // ],
    // [
    //   config.routes.families+'?q=Vanguard',
    //   'Vanguard',
    //   's'
    // ],
    // [
    //   config.routes.families+'?q=BlackRock%2FiShares',
    //   'BlackRock/iShares',
    //   's'
    // ],
    // [
    //   config.routes.families+'?q=State%20Street',
    //   'State Street',
    //   's'
    // ],
    // [
    //   config.routes.families,
    //   'More fund managers',
    //   's'
    // ],
  ],
  [
    [
      config.routes.toolkit,
      'Action toolkit',
      'l'
    ],
    [
      config.links.signup,
      'Sign up',
      'l',
      'envelope-o'
    ],
    [
      config.links.donate,
      'Donate to As You Sow',
      'l',
      'heart'
    ]
  ]
]

export default MenuConfig